export default "__VITE_ASSET__OZ_fl9Fl__"